export default function isRole(session: any, role: string): boolean {
    if (session && session.user && session.user.roles) {
        return session.user.roles.includes(role);
    }
    return false;
}
